if(!customElements.get('footer-menu')) {
  customElements.define(
    'footer-menu',
    class FooterMenu extends HTMLElement {
      #trigger;
      #linklist;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#trigger = this.querySelector('[data-trigger]');
        this.#linklist = this.querySelector('[data-linklist]')
        this.init();
      }

      init() {
        if(!this.#trigger) return;
        
        this.#trigger.addEventListener('click', () => {
          this.#trigger.classList.toggle('active');
          this.#linklist.classList.toggle('open');
        });
      }
    }
  );
}